import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash-es';

@Pipe({
  name: 'limitText'
})
export class LimitTextPipe implements PipeTransform {
    transform(inputValue: string, maxLength: number, append?: string, multiLine?: boolean): string {
        if (inputValue === undefined || inputValue === null || inputValue === '') {
            return '';
        }
        if (append === undefined) {
            append = '...';
        }

        if (multiLine === undefined) {
            multiLine = false;
        }

        var intermediate = inputValue.trim();
        var fullLength = intermediate.length;
        var firstLine = 0;

        // If multiLine is not allowed,
        // then only measure and show the
        // first line (up to the first newline/br)
        if (!multiLine) {
            // Multiply by -1 to avoid choosing "not found"
            // over an actual char index.
            firstLine = _.min([
                intermediate.indexOf("<br") * -1,
                intermediate.indexOf("</p") * -1,
                intermediate.indexOf('\n') * -1
            ]) * -1;  // Multiply it back to get the actual number
        }
        // Is there a line break somewhere inside the maxLength text?
        // If so, we break there instead (show the first line)
        if (firstLine > 0 && firstLine < maxLength) {
            return intermediate.substring(0, firstLine) + append;
        }

        // If no line break (or if we allow multi-line)
        // then trim to the max length
        if (fullLength > maxLength) {
            return intermediate.substring(0, maxLength - append.length) + append;
        }

        // This text isn't longer than max length, show the whole thing.
        return intermediate;
    }
};
